import { useEffect, useState, useMemo, useCallback } from "react";
import { TiDelete } from "react-icons/ti";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import {
  defaultFilterIncidents,
  getFlagPriorityIncident,
  getFormatDate,
  getIconStatusIncident,
  getNameIncidentsPriority,
  getNameIncidentsStatus,
  getNameIncidentsTypes,
  getNameUserSupport,
  getNameClient,
  getNamePlatform,
  translate,
} from "../../../../../utils/Common";

const VISIBLE_CHIPS = 5;

const SelectedFilters = (props) => {
  const { filterOptions, setFilterOptions } = props;
  const [isExpanded, setIsExpanded] = useState(false);
  const viewOptionsFilter = Object.entries(filterOptions).every(([key, array]) => {
    return array.length === 0;
  });

  const handleDeleteFilter = (filterKey, value) => {
    const newFilterOptions = { ...filterOptions };
    newFilterOptions[filterKey] = newFilterOptions[filterKey].filter(
      (item) => item !== value
    );
    setFilterOptions(newFilterOptions);
  };

  useEffect(() => {
    if (viewOptionsFilter) {
      setFilterOptions({ ...defaultFilterIncidents });
    }
  }, [viewOptionsFilter, setFilterOptions]);

  const allChips = useMemo(() => {
    const chips = [];
    filterOptions.typeIncident?.forEach((type) => {
      chips.push({
        key: `type-${type}`,
        label: translate("global.type"),
        value: getNameIncidentsTypes(type),
        onRemove: () => handleDeleteFilter("typeIncident", type),
        icon: null,
      });
    });
    filterOptions.priorityIncident?.forEach((priority) => {
      chips.push({
        key: `priority-${priority}`,
        label: translate("global.priority"),
        value: (
          <>
            {getFlagPriorityIncident(priority)}
            {getNameIncidentsPriority(priority)}
          </>
        ),
        onRemove: () => handleDeleteFilter("priorityIncident", priority),
        icon: null,
      });
    });
    filterOptions.statusIncident?.forEach((status) => {
      chips.push({
        key: `status-${status}`,
        label: translate("global.state"),
        value: (
          <>
            {getIconStatusIncident(status)}
            {getNameIncidentsStatus(status)}
          </>
        ),
        onRemove: () => handleDeleteFilter("statusIncident", status),
        icon: null,
      });
    });
    if (filterOptions.startDate?.length > 0) {
      const dateStr = `${getFormatDate(filterOptions.startDate[0] || "")} - ${getFormatDate(filterOptions.endDate?.[0] || "")}`;
      chips.push({
        key: `date-${filterOptions.startDate[0]}`,
        label: translate("global.dateCreated"),
        value: dateStr,
        onRemove: () => {
          setFilterOptions((prev) => ({ ...prev, startDate: [], endDate: [] }));
        },
        icon: null,
      });
    }
    filterOptions.assignedUser?.forEach((user) => {
      chips.push({
        key: `assignedUser-${user}`,
        label: translate("global.assignedTechnician"),
        value: getNameUserSupport(user),
        onRemove: () => handleDeleteFilter("assignedUser", user),
        icon: null,
      });
    });
    filterOptions.clientId?.forEach((client) => {
      chips.push({
        key: `client-${client}`,
        label: translate("global.client"),
        value: getNameClient(client),
        onRemove: () => handleDeleteFilter("clientId", client),
        icon: null,
      });
    });
    filterOptions.platformId?.forEach((platform) => {
      chips.push({
        key: `platform-${platform}`,
        label: translate("global.locker"),
        value: getNamePlatform(platform),
        onRemove: () => handleDeleteFilter("platformId", platform),
        icon: null,
      });
    });
    filterOptions.incidentId?.forEach((incidentId) => {
      chips.push({
        key: `incidentId-${incidentId}`,
        label: translate("global.incidentId"),
        value: `# ${incidentId}`,
        onRemove: () => handleDeleteFilter("incidentId", incidentId),
        icon: null,
      });
    });
    return chips;
  }, [filterOptions, handleDeleteFilter, setFilterOptions]);

  const visibleChips = isExpanded ? allChips : allChips.slice(0, VISIBLE_CHIPS);
  const hiddenCount = allChips.length - VISIBLE_CHIPS;
  const hasMore = hiddenCount > 0 && !isExpanded;

  if (viewOptionsFilter) return null;

  return (
    <div className="selected-filters-compact">
      {visibleChips.map((chip) => (
        <div key={chip.key} className="filter-option-incident filter-chip-compact">
          <span className="filter-chip-label">{chip.label}:</span>
          <span
            className="filter-chip-value"
            title={typeof chip.value === "string" ? chip.value : undefined}
          >
            {chip.value}
          </span>
          {chip.onRemove && (
            <button
              type="button"
              className="btn-delete-option-incident"
              onClick={chip.onRemove}
              aria-label="Remove filter"
            >
              <TiDelete size={14} />
            </button>
          )}
        </div>
      ))}
      {hasMore && (
        <button
          type="button"
          className="filter-chip-more"
          onClick={() => setIsExpanded(true)}
        >
          +{hiddenCount} {translate("dashboard.clients.platforms.more")}
          <IoChevronDown size={14} />
        </button>
      )}
      {isExpanded && allChips.length > VISIBLE_CHIPS && (
        <button
          type="button"
          className="filter-chip-more"
          onClick={() => setIsExpanded(false)}
        >
          {translate("global.seeLess")}
          <IoChevronUp size={14} />
        </button>
      )}
    </div>
  );
};

export default SelectedFilters;
